import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class ContinuousAuctionBatchLotUpModel extends BaseModel {
  quantity = null
  stock_no = null
  title = null
  reservations = []
  available_quantity = null
  inventory_uuid = null
  reserve_quantity = 1
  reserve_number = 1
  start_price = null;
  reserve = null;
  start_date = null;
  end_date = null;
  start_time = '10:00:00';
  end_time = '12:00:00';

  rules = {
    start_price: 'min_value:0',
    start_date: 'required',
    end_date: 'required',
    start_time: 'required',
    end_time: 'required',
  }

  customMessages = {
    "reserve_quantity": {
      max_value: function (name, rule) {
        if (rule.max === 0) {
          return i18n.t("Invalid number combination given")
        }
        return i18n.t('Reserve quantity cannot exceed {val}', {val: rule.max})
      }
    },
    "reserve_number": {
      max_value: function (name, rule) {
        if (rule.max === 0) {
          return i18n.t("Invalid number combination given")
        }
        return i18n.t('Reserve number cannot exceed {val}', {val: rule.max})
      }
    }
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initTranslatableFields(this);
  }
}
